import {defineCssVars as _defineCssVars} from '@chakra-ui/styled-system';

const prefix = `table` as const;

export const defineCssVars = (component: string, props: Array<string>) => {
  return _defineCssVars(`${prefix}-${component}`, props);
};

export const tableCSSVars = defineCssVars(`table`, [`radii`, `padding`]);
